import React from 'react';
import styles from './ContactOptionsMenu.module.scss';
import DropdownMenu from '@components/Menus/DropdownMenu';
import { ContactActionIcon } from '@components/Icons';
import { ID } from '@app/types';
import { useContactPersonOptions } from '@hooks/use-contact-person-options';

export const ContactOptionsMenuTrigger = ({ isOpen }) => (
  <ContactActionIcon width="24" height="24" isOpen={isOpen} hoverOpacity hover={false} />
);

export default function ContactOptionsMenu({
  contactID,
  onOpen,
  onClose,
}: {
  contactID: ID;
  onOpen?: () => void;
  onClose?: () => void;
}) {
  const [options, handleOpen] = useContactPersonOptions(contactID, { onOpen });

  return (
    <DropdownMenu
      options={options}
      menuClassName={styles.contactOptionsMenu}
      triggerClassName={styles.contactOptionsMenuTrigger}
      onOpen={handleOpen}
      onClose={onClose}
      expandFrom={'top-center'}
      triggerVariant="contactOptions"
    />
  );
}
